export default "__VITE_ASSET__8YuMIC9R__"